// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2yUzG","left":"StickyBox_left__J7vof","right":"StickyBox_right__A1ANC"};